<template>
  <!-- 礼包列表 -->
  <section class="section goods">
    <!-- 标题 -->
    <div class="empty-title"></div>
    <!-- <div v-if="isProductionTax" class="empty-title"></div>
    <div class="title bold" v-else>
      <div class="title-content">
        <AutoFitComponent class="flex" align="center" :key="titleKey">{{
          $t('game.packageTitle')
        }}</AutoFitComponent>
      </div>
    </div> -->

    <!-- 活动倒计时 -->
    <Cutdown
      :context="activityData.activity_notice"
      :cutdownTime="time"
      v-if="activityData.activity_notice && activityData.cutdown_time > 0"
    />

    <!-- 商品列表 -->
    <div class="goods-list">
      <template v-if="isRequestingPackageList && goodList.length === 0">
        <LoadingItem v-for="i in 10" :key="i" />
      </template>
      <GoodItem
        v-for="item in goodList"
        :key="item.id"
        :item="item"
        :checkList="checkList"
        :moneyunit="moneyUnit"
        :packageid="packageId"
        @click="selpackage(item)"
      />
      <!-- 无商品 -->
      <div class="nopackage regular" v-if="goodList.length === 0">
        <p>{{ $t('game.packageLoadingText') }}</p>
      </div>
    </div>
    <!--  -->
  </section>
</template>

<script>
import GoodItem from './GoodsItem.vue'
import LoadingItem from './LoadingItem.vue'
import Cutdown from './Cutdown.vue'
import { mapState } from 'vuex'
export default {
  name: 'GoodsList',
  components: {
    GoodItem,
    LoadingItem,
    Cutdown,
  },
  computed: {
    ...mapState({
      isLogin: (state) => state.user.isLogin,
      // isProductionTax: (state) => state.app.isProductionTax,
    }),
  },
  props: {
    // 商品列表
    goodList: {
      type: Array,
      default: () => [],
    },
    isRequestingPackageList: {
      type: Boolean,
      default: false,
    },
    checkList: {
      type: Array,
      default: () => [],
    },
    moneyUnit: {
      type: String,
      default: '',
    },
    packageId: {
      type: String | Number,
      default: '',
    },
    activityData: {
      type: Object,
      default: () => ({
        activity_notice: '',
        cutdown_time: 0,
      }),
    },
  },

  data() {
    return {
      timer: null,
      time: 0,

      titleKey: 0,
      titleTimer: null,
    }
  },

  watch: {
    'activityData.cutdown_time': {
      handler(newVal) {
        if (newVal > 0) {
          this.initCutdown()
        }
      },
    },
  },

  mounted() {
    this.titleTimer = setInterval(() => {
      if (this.titleKey >= 10) {
        clearInterval(this.titleTimer)
        this.titleTimer = null
        return
      }
      this.titleKey++
    }, 100)
  },

  methods: {
    selpackage(item) {
      this.$emit('goodItemClick', item)
    },
    initCutdown() {
      this.time = this.activityData.cutdown_time
      this.stopCutdown()
      this.timer = setInterval(() => {
        this.time--
        if (this.time <= 0) {
          console.log('=========shopUpdated1')
          this.$confirm({
            content: this.$t('game.shopUpdated'),
            hideClose: true,
            hideCancel: true,
            confirm: () => {
              window.location.reload(true)
            },
          })
          this.stopCutdown()
        }
      }, 1000)
    },
    stopCutdown() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
  },
  beforeDestroy() {
    this.stopCutdown()
  },
}
</script>
<style scoped lang="less">
.goods {
  .empty-title {
    height: 20px;
  }
  .title-content {
    max-width: 75vw;
  }
  .goods-list {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 11px;
    max-width: 912px;
    margin: 0 auto 10px;
    position: relative;
    box-sizing: border-box;
    padding: 0 2px;
  }
}
/* 响应式列数控制 */
@media (max-width: 313px) {
  .goods .goods-list {
    grid-template-columns: repeat(1, 1fr);
  }
}
@media (min-width: 554px) {
  .goods .goods-list {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (min-width: 555px) {
  .goods .goods-list {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media (min-width: 733px) {
  .goods .goods-list {
    grid-template-columns: repeat(4, 1fr);
  }
}
@media (min-width: 912px) {
  .goods .goods-list {
    grid-template-columns: repeat(5, 1fr);
  }
  .goods .title-content {
    max-width: 912px;
  }
}
</style>
